import React from "react";
import "./LoanDetails.scss";

function LoanProgressBar({ width, color, leftText, rightText, title }) {
  return (
    <div className="progress-container">
      <div className="text-center mb-3 progress-title">{title}</div>
      <div className="d-flex justify-content-between">
        <div className="progress-bar-text">{leftText}</div>
        <div className="progress-bar-text">{rightText}</div>
      </div>

      <div
        class="progress"
        role="progressbar"
        aria-label="Success example"
        aria-valuenow="25"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div className={`progress-bar ${color}`} style={{ width: width }}></div>
      </div>
    </div>
  );
}

export default LoanProgressBar;
